import { IBlotterUpdate } from '../../interfaces';
import { injectable } from 'inversify';
import { IOrdersAggregatorService } from './orders-aggregator.interface';
import { NEVER, Observable } from 'rxjs';

@injectable()
export class OrdersAggregatorMock implements IOrdersAggregatorService {
    ordersObservable(): Observable<IBlotterUpdate> {
        return NEVER;
    }
}
